import { UserTypeAction, UserInitialStateType } from '.';
const initialState: UserInitialStateType = {
	isAuthenticated: false,
	loading: false,
	isRegistered: false,
	token: localStorage.getItem('token'),
};
import { UserTypes } from './Types';
export const userReducer = (state = initialState, action: UserTypeAction) => {
	switch (action.type) {
		case UserTypes.Welcome:
			return { ...state, welcome: action.payload.data };
		case UserTypes.Login:
			localStorage.setItem('parentId', action.payload.data.userExists.id);
			localStorage.setItem('token', action.payload.data.token);
			localStorage.setItem('currentChild', action.payload.data.userExists.Children[0].fullName);
			localStorage.setItem('currentChildId', action.payload.data.userExists.Children[0].id);
			return {
				...state,
				login: { ...action.payload, loading: false },
				isAuthenticated: true,
				errors: undefined,
			};

		case UserTypes.ADMIN_LOGIN:
			// eslint-disable-next-line no-console
			// console.log(action.payload.data.token);
			localStorage.setItem('admin-token-here', action.payload.data.token);
			return {
				...state,
				login: { ...action.payload, loading: false },
				isAuthenticated: true,
				errors: undefined,
			};
		case UserTypes.Registration:
			return { ...state, isRegistered: true, register: action.payload, errors: undefined };
		case UserTypes.Errors:
			localStorage.removeItem('token');
			localStorage.removeItem('currentChild');
			localStorage.removeItem('currentChildId');
			localStorage.removeItem('parentId');
			return { ...state, errors: { ...action.payload.errors, loading: false } };

		case UserTypes.LOADING_PROFILE:
			return { ...state, loading: true, errors: undefined };
		case UserTypes.PROFILE_FAIL:
			localStorage.removeItem('token');
			localStorage.removeItem('currentChild');
			localStorage.removeItem('currentChildId');
			localStorage.removeItem('parentId');
			return { ...state, loading: false };
		case UserTypes.PROFILE_SUCCESS:
			return { ...state, isAuthenticated: true, loading: true, errors: undefined };
		case UserTypes.LOGOUT_USER:
			localStorage.removeItem('token');
			localStorage.removeItem('currentChild');
			localStorage.removeItem('currentChildId');
			localStorage.removeItem('parentId');
			return {
				...state,
				isAuthenticated: false,
				errors: undefined,
				login: undefined,
				register: undefined,
			};
		case UserTypes.LoginError:
			localStorage.removeItem('token');
			localStorage.removeItem('currentChild');
			localStorage.removeItem('currentChildId');
			localStorage.removeItem('parentId');
			return { ...state, errors: { ...action.payload.errors, loading: false } };
		default:
			return state;
	}
};
